// Event listener for the review stars on the PDP
// when clicked, it smoothly scrolls the user to the reviews section at the bottom of the page

document.addEventListener('DOMContentLoaded', () => {
  const starContainer = document.querySelector('.yotpo.bottomLine');

  if (starContainer) {
    starContainer.addEventListener('click', (event) => {
      event.preventDefault();
      const reviewsSection = document.getElementById('yotpo-reviews-main-widget');

      if (reviewsSection) {
        reviewsSection.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }
    });
  }
});
